/**
 * @desc notSupport 适用于使用promise的api
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
export var notSupportForPromise = function() {
    return Promise.resolve({
        notSupport: true
    });
};
/**
 * @desc notSupport 适用于无法promise化的api,e.g. 事件监听等
 */ export var notSupportForCallback = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = _sliced_to_array(args, 2), options = _args[0], callback = _args[1];
    var _callback = function(argument) {
        console.log(argument);
    };
    if (typeof options === 'function') {
        _callback = options;
    } else if (typeof callback === 'function') {
        _callback = callback;
    }
    _callback({
        notSupport: true
    });
};
/**
 * @desc notSupport 构建使用
 */ export var notSupportForObjForm = function(options, callback) {
    var cb = callback;
    if (typeof options === 'function' && !callback) cb = options;
    if (cb) {
        return cb({
            notSupport: true
        });
    }
    return Promise.resolve({
        notSupport: true
    });
};
/**
 * @desc notSupport 适用于使用promise的api
 */ export var notSupportForVariable = function() {
    return 'notSupportForVariable';
};
